var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.499,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    d: "m16.327 15.49-3.64-3.64a7.14 7.14 0 0 0 1.707-4.653 7.15 7.15 0 0 0-2.108-5.09A7.15 7.15 0 0 0 7.196 0a7.15 7.15 0 0 0-5.088 2.108A7.15 7.15 0 0 0 0 7.197a7.15 7.15 0 0 0 2.108 5.09 7.15 7.15 0 0 0 5.089 2.107 7.15 7.15 0 0 0 4.653-1.707l3.64 3.64a.59.59 0 0 0 .418.172.592.592 0 0 0 .419-1.01M2.944 11.45a6.02 6.02 0 0 1 0-8.506 5.98 5.98 0 0 1 4.254-1.763c1.608 0 3.117.625 4.255 1.763a6.02 6.02 0 0 1 0 8.506c-2.349 2.344-6.165 2.344-8.51 0"
  })));
};
export default SvgSearch;